(() => {
  const playerSelector = 'internal-video[data-deferred-video="true"]';
  const initializedPlayers = new WeakSet();
  const observedPlayers = new WeakSet();

  const loadVideo = (player, isUserInitiated = false) => {
    const video = player.querySelector('video');

    if (!video || video.dataset.deferredLoaded === 'true') return;

    const sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;

    video.preload = isUserInitiated ? 'auto' : 'metadata';
    sources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.deferredLoaded = 'true';

    if (isUserInitiated) player.classList.add('internal-video--loading');
    video.load();
  };

  const preloadObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            loadVideo(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '300px 0px', threshold: 0 }
      )
    : null;

  const isVisible = (player) =>
    player.getClientRects().length > 0 && getComputedStyle(player).visibility !== 'hidden';

  const initializePlayer = (player) => {
    if (initializedPlayers.has(player)) return;

    const video = player.querySelector('video');
    if (!video) return;

    initializedPlayers.add(player);
    video.addEventListener('waiting', () => player.classList.add('internal-video--loading'));
    ['playing', 'canplay', 'error'].forEach((eventName) => {
      video.addEventListener(eventName, () => player.classList.remove('internal-video--loading'));
    });
  };

  const initializePlayers = (root = document) => {
    const allPlayers = Array.from(root.querySelectorAll(playerSelector));
    allPlayers.forEach(initializePlayer);

    const players = allPlayers.filter(
      (player) => !player.closest('.splide__slide--clone') && isVisible(player)
    );
    const firstPlayerByGroup = new Map();

    players.forEach((player) => {
      const group = player.closest('splide-component, .shopify-section') || player.parentElement;

      if (!firstPlayerByGroup.has(group)) firstPlayerByGroup.set(group, player);
    });

    players.forEach((player) => {
      const group = player.closest('splide-component, .shopify-section') || player.parentElement;
      const shouldPreload = player.dataset.autoplay === 'true' || firstPlayerByGroup.get(group) === player;

      if (!shouldPreload || observedPlayers.has(player)) return;

      observedPlayers.add(player);
      if (preloadObserver) preloadObserver.observe(player);
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const playButton = event.target.closest(`${playerSelector} .internal-video__play`);
      if (!playButton) return;

      loadVideo(playButton.closest(playerSelector), true);
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => initializePlayers(event.target));

  initializePlayers();
})();
